var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { row: "", wrap: "" } },
    [
      _c(
        "form-template",
        {
          ref: "child-component",
          attrs: { title: "Strategy Configuration", "enable-submit": true },
          on: { save: _vm.onSave, cancel: _vm.onCancel },
        },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _vm.guidelineDefaultValues.isLoading
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [_c("v-progress-linear", { attrs: { indeterminate: "" } })],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.guidelineDefaultValues.isLoading
                ? _c("v-flex", { attrs: { xs12: "" } }, [
                    _vm._v(
                      "Please provide static values for the guideline cofactors\n        below"
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.cofactors, function (cofactor) {
                return _c(
                  "v-flex",
                  { key: cofactor.key, attrs: { xs12: "", "pb-3": "" } },
                  [
                    _c("cofactor-input", {
                      model: {
                        value: cofactor.data,
                        callback: function ($$v) {
                          _vm.$set(cofactor, "data", $$v)
                        },
                        expression: "cofactor.data",
                      },
                    }),
                  ],
                  1
                )
              }),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500", persistent: "" },
          model: {
            value: _vm.confirmPartialForm,
            callback: function ($$v) {
              _vm.confirmPartialForm = $$v
            },
            expression: "confirmPartialForm",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v(
                  "Not all static cofactor values are set. Are you sure you want to proceed?\n      "
                ),
              ]),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v(
                  "Warning: Some guidelines may not be able to be calculated if static cofactor values are missing.\n        If you would like to fill in missing cofactor information after saving, you can provide the information\n        through the configuration window of the cofactor calculation management page."
                ),
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "add", flat: "flat" },
                      nativeOn: {
                        click: function ($event) {
                          _vm.confirmPartialForm = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "add", flat: "flat" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.onConfirmSave.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.SaveStrategy")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }